import theme from 'theme';

// for more information regarding IUBenda go to:
// https://www.iubenda.com/en/help/1205-how-to-configure-your-cookie-solution-advanced-guide#examples
export type IUBendaConfig = {
  ccpaApplies: boolean;
  consentOnContinuedBrowsing: boolean;
  enableCcpa: boolean;
  invalidateConsentWithoutLog: boolean;
  perPurposeConsent: boolean;
  whitelabel: boolean;
  lang: string;
  siteId: number;
  consentOnDocument: boolean;
  consentOnHorizontalScroll: boolean;
  cookiePolicyInOtherWindow: boolean;
  cookiePolicyId: number;
  banner: {
    explicitWithdrawal: boolean;
    listPurposes: boolean;
    closeButtonDisplay: boolean;
    acceptButtonColor: string;
    acceptButtonCaptionColor: string;
    rejectButtonColor: string;
    rejectButtonCaptionColor: string;
    acceptButtonDisplay: boolean;
    customizeButtonDisplay: boolean;
    position: string;
    rejectButtonDisplay: boolean;
    applyStyles: boolean;
    content: string;
  };
  callback: {
    onConsentGiven: () => void;
    onConsentRejected: () => void;
  };
};

const defaultConfiguration: IUBendaConfig = {
  ccpaApplies: true,
  consentOnContinuedBrowsing: false,
  enableCcpa: true,
  invalidateConsentWithoutLog: true,
  perPurposeConsent: true,
  cookiePolicyInOtherWindow: true,
  whitelabel: false,
  lang: 'en',
  siteId: 2007936,
  consentOnDocument: true,
  consentOnHorizontalScroll: true,
  cookiePolicyId: 97095809,
  banner: {
    applyStyles: false,
    acceptButtonDisplay: true,
    customizeButtonDisplay: true,
    rejectButtonDisplay: true,
    closeButtonDisplay: true,
    explicitWithdrawal: true,
    listPurposes: true,
    position: 'float-bottom-center',
    acceptButtonColor: theme.palette.primary.main,
    acceptButtonCaptionColor: theme.palette.primary.contrastText,
    rejectButtonColor: theme.palette.grey[600],
    rejectButtonCaptionColor: theme.palette.grey[700],
    content: `<div id="iubenda-cs-title">Notice</div><div id="iubenda-cs-paragraph">We and selected third parties use cookies or similar technologies for technical, analytics and advertising purposes. Your personal data may be used for personalization of ads and cookies may be used for personalized and non-personalized advertising. Detailed information is specified in the <a href="/privacy-policy/97095809/cookie-policy?an=no&s_ck=false&newmarkup=yes" class="iubenda-cs-cookie-policy-lnk">cookie policy</a>.</div>`,
  },
  callback: {
    onConsentGiven: () => {
      // by default do nothing
    },
    onConsentRejected: () => {
      // by default do nothing
    },
  },
};

export default defaultConfiguration;
